/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
// importer la librairie de react
import React, { useEffect, useRef, useState } from "react"
import {
    Box,
    Checkbox,
    FormControl,
    FormHelperText,
    Icon,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
    Typography,
} from "@mui/material"
import InputLabel from "@mui/material/InputLabel"
import { useTranslation } from "react-i18next"
import { PageConfig, CwComponentConfig } from "../../models/pageConfig"
import StoreService from "../../services/store"
import ActionService from "../../services/action"
import UIService from "../../services/UIService"
import ComponentsUtils from "../../utils/components"
import DynamicParamsService from "../../services/dynamicParams"
import StructUtils from "../../utils/structUtils"
import { DisplayValueModel } from "../../models/displayValue"
import { Color } from "../../models/colors"
import DialogService from "../../services/dialog"
import { DialogType } from "../../models/dialog"
import FormFieldService from "../../services/formField"
import CwIcon from "./cw-icon"

const CwSelect = (
    props: PageConfig<CwComponentConfig.SelectWeb>
): React.JSX.Element | null => {
    const { config } = props
    // création de toute les variables à partir des config
    const {
        variant,
        fieldName,
        edit,
        formLink,
        error,
        variantTypo,
        labelIcon,
        onChangeActions,
        readOnly,
        displayValueMapping,
        valueMapping,
        useRefreshListener,
        useConfigListener,
        autoDefaultSelect,
        multiple = false,
        native = true,
        context,
        labelClassName,
    } = config
    // const defaultValue = config.defaultValue || ""
    const [state, setState] = useState({
        isLoading: true,
    })
    const color = UIService.getColorByName(
        config.color ? config.color : Color.black
    )
    const borderColor = UIService.getColorByName(
        config.borderColor ? config.borderColor : Color.black
    )
    const iconColor = UIService.getColorByName(
        config.iconColor ? config.iconColor : Color.black
    )
    const backgroundColor = UIService.getColorByName(
        config.backgroundColor ? config.backgroundColor : Color.transparent
    )
    const dropDownColor = UIService.getColorByName(
        config.dropdownColor ? config.dropdownColor : config.backgroundColor
    )

    const className = config.className ? config.className : ""
    const classNameSelect = config.classNameSelect ? config.classNameSelect : ""
    const displayNullValue = config.displayNullValue
        ? config.displayNullValue
        : ""
    const displayNull = config.displayNull ? config.displayNull : false
    const displayNullLabel = config.displayNullLabel
        ? DynamicParamsService.resolveLang(config.displayNullLabel)
        : undefined
    const [values, setValues] = React.useState<Array<DisplayValueModel> | null>(
        null
    )
    const [value, setValue] = React.useState<any>(
        config.value || (multiple ? [] : undefined)
    )
    const valueRef = useRef<any>(null)
    const [errorState, setError] = React.useState<{
        hasError: boolean
        helperText?: string
    }>({ hasError: false, helperText: "" })
    const [label, setLabel] = useState<string>(
        DynamicParamsService.resolveLang(config.label)
    )
    const placeholder = DynamicParamsService.resolveLang(config.placeholder)

    const [hidden, setHidden] = useState<boolean>(config.hidden || false)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    /**
     * récupère l'état (présence d'erreur) du champ
     * @param field nom du champ
     * @param currentValue nouvelle value
     */
    const getFormState = (field: string, currentValue: unknown) => {
        const s = FormFieldService.getInstance().send(
            formLink,
            field,
            currentValue
        )
        if (
            s &&
            (s.error !== errorState.hasError || s.msg !== errorState.helperText)
        ) {
            setError({
                hasError: s.error,
                helperText: s.msg,
            })
        }
    }
    const { t } = useTranslation()

    /**
     * Execute les actions custom
     * @param e event onChange Select
     */
    const handleActions = (e: any) => {
        // set state
        const newValue = e.target.value
        setValue(newValue)
        // transmission de l'event au composant pere (CwForm)
        if (fieldName) {
            StoreService.getInstance().local.set(fieldName, e.target.value)
            getFormState(fieldName, newValue)
        } else if (fieldName)
            StoreService.getInstance().local.set(fieldName, e.target.value)
        // exec liste d'actions si disponibles
        if (onChangeActions?.length) {
            ActionService.exec(onChangeActions, { ...e, parent: context })
        }
    }

    /**
     * Initialisation du composant.
     * Les actions d'init sont ex cut es, et le r sultat est stock  dans le state.
     * Si le composant a une valeur initiale, elle est r solue par DynamicParamsService si elle contient des valeurs dynamiques.
     * Si le composant a une valeur initiale et qu'elle est r solue, elle est stock e dans le state.
     * Si autoDefaultSelect est vrai, le composant est auto-s lectionn  sur la premi re valeur du mod le.
     * @param forceValue valeur finale forcer
     */
    const init = async (forceValue?: any) => {
        setIsLoading(true)
        try {
            /** Resolve the value if provided */
            if (fieldName) {
                if (
                    !forceValue &&
                    value &&
                    value.indexOf &&
                    value.indexOf("{{#") !== -1
                ) {
                    DynamicParamsService.resolve([value], config.context).then(
                        (resolvedValue: any) => {
                            if (resolvedValue?.length && fieldName) {
                                const newValue =
                                    resolvedValue[0] || (multiple ? [] : "")
                                setValue(newValue)
                                // eslint-disable-next-line prefer-destructuring
                                valueRef.current = newValue
                            }
                            StoreService.getInstance().local.set(
                                fieldName,
                                resolvedValue[0]
                            )
                            setState({ isLoading: false })
                        }
                    )
                } else {
                    const newValue =
                        forceValue !== undefined ? forceValue : value
                    setValue(newValue)
                    StoreService.getInstance().local.set(fieldName, newValue)
                    setState({ isLoading: false })
                }
            }
            // exec les actions d'init
            if (props.actions && props.actions.length) {
                const result = await ActionService.exec(props.actions)
                let currentRes = result
                // si les config viennent d'une action CONFIG on extrait la valeur de la conf
                if (result?.type === "config") currentRes = result.value
                let val: any[] = []
                // si on doit adapter le model vers {displayValue: string, value: string}
                if (displayValueMapping && valueMapping && currentRes) {
                    const v = StructUtils.toDisplayValueModel(
                        displayValueMapping,
                        valueMapping,
                        currentRes
                    )
                    val = v || []
                } else if (currentRes) {
                    val = currentRes
                }

                // Ensure val is an array
                if (!Array.isArray(val)) {
                    val = []
                }

                // Set values first
                setValues(val)

                // Only attempt auto-select if we have values and autoDefaultSelect is enabled
                if (autoDefaultSelect) {
                    // Determine the appropriate value to select
                    let autoSelectVal

                    // If we have a stored value reference, use it
                    if (
                        valueRef.current !== null &&
                        valueRef.current !== undefined
                    ) {
                        autoSelectVal = valueRef.current
                    }
                    // Otherwise extract from the first item based on mapping
                    else if (Array.isArray(val) && val.length > 0) {
                        if (
                            valueMapping &&
                            val[0][valueMapping] !== undefined
                        ) {
                            autoSelectVal = val[0][valueMapping]
                        } else if (val[0].value !== undefined) {
                            autoSelectVal = val[0].value
                        } else {
                            // Fallback if the expected structure isn't found
                            autoSelectVal = multiple ? [] : ""
                        }
                    }

                    // Format the value correctly for multiple/single select
                    const formattedValue =
                        multiple && !Array.isArray(autoSelectVal)
                            ? [autoSelectVal]
                            : !multiple &&
                              Array.isArray(autoSelectVal) &&
                              autoSelectVal.length > 0
                            ? autoSelectVal[0]
                            : autoSelectVal

                    // Only trigger handleActions if we have a valid value
                    if (
                        formattedValue !== undefined &&
                        formattedValue !== null
                    ) {
                        // Use setTimeout to ensure this happens after state updates
                        setTimeout(() => {
                            handleActions({ target: { value: formattedValue } })
                        }, 0)
                    }
                }
            }
        } catch (err) {
            console.error("Error in CwSelect init:", err)
            setState({ isLoading: false })
        }
        setIsLoading(false)
    }

    /**
     * Affiche la displayValue en foncton de la valeur
     * @param v value
     */
    // const displayValueFromValue = (v: string) => {
    //     if (values?.length) {
    //         const res = values.find((val) => val.value === v)
    //         return res?.displayValue ? res.displayValue : v
    //     }
    //     return v
    // }
    const displayValueFromValue = (v: string | string[]): any => {
        if (Array.isArray(v)) {
            // Map the array to return an array of display values
            return v.map((val) => displayValueFromValue(val)).join(", ")
        }

        if (values?.length) {
            const res = values.find((val) => val.value === v)
            return res?.displayValue ? res.displayValue : v
        }
        return v
    }

    useEffect(() => {
        // si il y a une erreur remonté par le form alors on fait une interofgation pour avoir le nouveau formState
        if (error && fieldName)
            getFormState(
                fieldName,
                StoreService.getInstance().local.get(fieldName)
            )

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error])

    useEffect(() => {
        let subRefreshId: string | null = null
        let subConfigId: string | null = null
        // on s'abonne aux changements de route
        if (useRefreshListener)
            subRefreshId = DialogService.getInstance().subscribe(
                "pageRefesh",
                DialogType.REFRESH,
                props.name,
                () => {
                    init(multiple ? [] : undefined)
                }
            )
        // abonnement aux changments de config
        if (useConfigListener)
            subConfigId = DialogService.getInstance().subscribe(
                "all",
                DialogType.CONFIG,
                props.name,
                (param: any) => {
                    if (param?.label) {
                        setLabel(DynamicParamsService.resolveLang(param.label))
                    }
                    if (typeof param.hidden === "boolean") {
                        setHidden(param.hidden)
                    }
                }
            )

        init()
        // unsubscribe
        return () => {
            if (subRefreshId)
                DialogService.getInstance().unsubscribe(subRefreshId)
            if (subConfigId)
                DialogService.getInstance().unsubscribe(subConfigId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return state.isLoading ? (
        ComponentsUtils.renderLoader()
    ) : edit && !hidden ? (
        <Box className={`typoBox justify-content-center ${className}`}>
            {labelIcon ? (
                <CwIcon
                    name="FilterAltOutlinedIcon"
                    type="icon"
                    config={{
                        name: labelIcon,
                        fontSize: "medium",
                        clickable: false,
                        color: color as Color,
                        className: "selectIcon",
                    }}
                />
            ) : null}

            {values ? (
                <FormControl
                    variant={variant}
                    sx={{
                        minWidth: "180px",
                        width: "100%",
                        "& .MuiInputLabel-root": {
                            color,
                        },
                    }}
                    disabled={readOnly}
                    error={errorState.hasError}
                >
                    {values.length ? (
                        <>
                            <InputLabel id="select-label" shrink={true}>
                                {label}
                            </InputLabel>
                            <Select
                                multiple={multiple}
                                notched
                                className={classNameSelect}
                                sx={{
                                    color,
                                    ".MuiOutlinedInput-notchedOutline": {
                                        borderColor: borderColor || color,
                                    },
                                    ".MuiSvgIcon-root ": {
                                        fill: `${
                                            iconColor || color
                                        } !important`,
                                    },
                                }}
                                input={
                                    multiple ? (
                                        <OutlinedInput label="Tag" />
                                    ) : undefined
                                }
                                displayEmpty
                                native={native}
                                value={value}
                                inputProps={{
                                    name: fieldName,
                                    id: "select-outlined-label",
                                }}
                                onChange={handleActions}
                                renderValue={(selected) =>
                                    multiple
                                        ? value
                                              .map((val: any) => {
                                                  const selectedItem =
                                                      values?.find(
                                                          (
                                                              item: DisplayValueModel
                                                          ) =>
                                                              item.value === val
                                                      )
                                                  return selectedItem
                                                      ? DynamicParamsService.resolveLang(
                                                            selectedItem.displayValue
                                                        )
                                                      : val
                                              })
                                              .join(", ")
                                        : null
                                }
                                label={label}
                            >
                                {displayNull ? (
                                    <option
                                        value={
                                            displayNullLabel
                                                ? displayNullValue
                                                : undefined
                                        }
                                    >
                                        {displayNullLabel
                                            ? displayNullLabel
                                            : undefined}
                                    </option>
                                ) : (
                                    <option
                                        value=""
                                        style={{ display: "none", color }}
                                    >
                                        {placeholder}
                                    </option>
                                )}
                                {!multiple &&
                                    values.map((val) => (
                                        <option
                                            style={{
                                                background: config.dropdownColor
                                                    ? dropDownColor
                                                    : backgroundColor,
                                            }}
                                            key={val.value}
                                            value={val.value}
                                        >
                                            {val.displayValue}
                                        </option>
                                    ))}
                                {multiple &&
                                    values.map((val) => (
                                        <MenuItem
                                            key={val.value}
                                            value={val.value}
                                        >
                                            <Checkbox
                                                checked={value.includes(
                                                    val.value
                                                )}
                                            />
                                            <ListItemText
                                                primary={val.displayValue}
                                            />
                                        </MenuItem>
                                    ))}
                            </Select>
                        </>
                    ) : (
                        <TextField
                            disabled={true}
                            sx={{ color }}
                            label={label}
                        ></TextField>
                    )}
                    <FormHelperText error>
                        {t(errorState.helperText as string)}
                    </FormHelperText>
                </FormControl>
            ) : (
                ComponentsUtils.renderLoader()
            )}
        </Box>
    ) : !hidden ? (
        <Box className={`typoBox ${className}`}>
            <Typography
                className={`labelType ${labelClassName}`}
                variant="caption"
                sx={{ color }}
            >
                {labelIcon ? (
                    <Icon className="labelIcon">{labelIcon}</Icon>
                ) : null}
                {label ? `${label}: ` : ""}
            </Typography>
            <Typography variant={variantTypo} style={{ color }}>
                {displayValueFromValue(value)}
            </Typography>
        </Box>
    ) : null
}
export default CwSelect
